import type { FaireProductEntity } from "../../entity_types/product";

export const p_kfen4wu85m: FaireProductEntity = {
  token: "p_kfen4wu85m",
  type: "product",
  name: "Sugar Pine + Fig",
  brandToken: "b_e9jbwwg3he",
  brandName: "Moonrise Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/086d8a6d6b950a03ef30e736bce04e080556ec5b27d3ffbbf766bd77e4ac59bf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f16ee5756a33e6fc7aa1c5834abd8f2fcecf8fca680fec345a0fa448fa8d9100.jpeg",
    "https://cdn.faire.com/fastly/acc39b5b51578aedb0ab631517e1e45dfc8ff5e4afb0d4d9fc8345ce77c65748.jpeg",
    "https://cdn.faire.com/fastly/4e8346270f6948254c9d337265cecc111060d96dab2259712ff511d09d47721f.jpeg",
    "https://cdn.faire.com/fastly/e4e7e49820fa9767ac62c8d96d28ccd1da2ac60d341014a1f08a1512815d321a.jpeg",
  ],
  priceDollars: 6,
  description:
    "Crisp and clean sugar pine combines with a vibrant blend of sun-ripened figs and green apple to create a sweet yet earthy tone. Paired with a base of sandalwood and rosewood, light this candle and venture deep into the evergreen.\n\n𝐁𝐮𝐫𝐧 𝐓𝐢𝐦𝐞:\n\n• 4 oz - 20+ hours\n• 7.5 oz - 45+ hours\n• 15 oz - 90+ hours",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:04.804Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
